import React, { useEffect, useState } from 'react'
import { Box, 
    IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
    Snackbar,
    Alert,
    Card} 
    from '@mui/material'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Link } from 'react-router-dom';
import axiosInstance from '../axiosConfig';

export default function CateringsMenus() {
  const [categories, setCategories] = useState([])
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')
  const [filterText, setFilterText] = useState("")
  const [page, setPage] = useState(0);  // Current page index
  const [rowsPerPage, setRowsPerPage] = useState(5);  // Number of rows per page
  const [open, setOpen] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [cateringMenus, setCateringMenus] = useState([])
    const serviceAPI = process.env.REACT_APP_API_SERVICE;

  const [newCateringMenu, setNewCateringMenu] = useState({
    name: '',
    size: '',
    price: '',
    category: '',
    availability: '',
    description: ''
  })

  const [editCateringMenu, setEditCateringMenu] = useState({
    name: '',
    size: '',
    price: '',
    category: '',
    availability: '',
    description: ''
  })

  const handleClickOpenEdit = (menu) => {
    setEditCateringMenu(menu)
    setOpenEdit(true)
  }

  const handleChange = (e) => {
    setNewCateringMenu({...newCateringMenu, [e.target.name]: e.target.value});
  }

  const handleChangeEdit = (e) => {
    setEditCateringMenu({...editCateringMenu, [e.target.name]: e.target.value})
  }

  const handleConfirmOpen = (id) => {
    setDeleteId(id)
    setConfirmOpen(true)
  }
  const handleConfirmClose = (id) => {
    setDeleteId(null)
    setConfirmOpen(false)
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCloseEdit = () => {
    setOpenEdit(false)
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false)
  }

  const handleDelete = async (id)  => {
     setSnackbarOpen(true)
    try {
        await axiosInstance.delete(`${serviceAPI}/cateringmenu/${id}`);
        setCateringMenus(cateringMenus.filter(cateringMenu => cateringMenu.id !== id));

        setSnackbarMessage("Menu was deleted successfully!")
        setSnackbarSeverity("success")

        handleConfirmClose()
    } catch (error) {
        console.log('Error occured deleting the Menu: ', error);
        setSnackbarMessage("An error occured trying to delete a Menu.")
        setSnackbarSeverity("warning")
    }
  };

  const handleEditCateringMenu = async () => {
    setSnackbarOpen(true)
    try {
        const response = await axiosInstance.post(`${serviceAPI}/cateringmenu/update`, {
            ...editCateringMenu,
            updatedAt: new Date().toISOString(),  // Set current datetime
        });
        setCateringMenus(cateringMenus.map(menu =>
            menu.id === editCateringMenu.id ? response.data : menu
        ));
        setSnackbarMessage("Menu was updated successfully!")
        setSnackbarSeverity("success")
        handleCloseEdit();
    } catch (error) {
       setSnackbarMessage("There was an error updating the Menu! Please try again")
       setSnackbarSeverity("warning")
       console.log('Error occured updating the menu', error)
    }
  }

  const handleAddCateringMenu = async () => {
    setSnackbarOpen(true)
    try {
        const response = await axiosInstance.post(`${serviceAPI}/cateringmenu`, {
            ...newCateringMenu,
            createdAt: new Date().toISOString(),  // Set current datetime
        });
        setCateringMenus([...cateringMenus, response.data])
        setNewCateringMenu({
            name: '',
            size: '',
            price: '',
            category: '',
            availability: '',
            description: ''
          });
          setSnackbarMessage("Catering Menu was added successfully!")
          setSnackbarSeverity("success")
          handleClose();
    }catch(error){
        setSnackbarMessage("There was an error adding a Catering Menu! Please try again")
        setSnackbarSeverity("warning")
        console.log('There was an error adding the product!', error)
    }
  }

    const handleCategoryChange = (event) => {
        const selectedCategory = event.target.value
        setNewCateringMenu({
            ...newCateringMenu,
            category: selectedCategory
        });
    }

  const handleFilterChange = (event) => {
    setFilterText(event.target.value)
    setPage(0)
  }

  const filteredCateringMenus  = cateringMenus.filter( cateringMenu =>
    (cateringMenu.name && cateringMenu.name.toLowerCase().includes(filterText.toLocaleLowerCase())) ||
    (cateringMenu.summary && cateringMenu.summary.toLowerCase().includes(filterText.toLocaleLowerCase()))
  );

  useEffect(() => {
    axiosInstance.get(`${serviceAPI}/cateringmenu`).then(response => {
      setCateringMenus(response.data)
    }).catch((error) => {
      console.log("There was an error fetching the catering menus", error)
    })
  }, []);

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category`).then(response => {
            setCategories(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the categories", error)
        })
    }, []);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle change in rows per page
const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);  // Reset the table to the first page whenever rows per page changes
};

  return (
    <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="20%"
    padding="2rem"
    border="ActiveBorder"
    fullWidth
  >
    <Card sx={{ width: '80%', padding: '2rem', border: '2px solid black', borderRadius: '8px' }}>
    <TableContainer>
        <Box display="flex" justifyContent="flex-start">
            <Button variant='contained' onClick={handleClickOpen}> Add New Catering Menu</Button>
        </Box>

        <Box display="flex" justifyContent="flex-end" >
          <TextField
            label="Search Menus"
            variant="outlined"
            value={filterText}
            onChange={handleFilterChange}
          >
          </TextField>
        </Box>
        <hr></hr>
        <Table aria-label="simple table">
            <TableHead>
              <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">#</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Description</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope='col'>Size</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Price($)</TableCell>
              <TableCell scope="col"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                { filteredCateringMenus !== null? filteredCateringMenus.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cateringmenu, index) => (
                <TableRow
                key={cateringmenu.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell sx={{ fontSize: '1.1rem' }} scope="row">{page * rowsPerPage + index + 1}</TableCell>

                <TableCell sx={{ fontSize: '1.1rem' }}><Link to={`/product`} state={{currentCateringMenu: cateringmenu}} >{cateringmenu.name}</Link></TableCell>

                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.description}</TableCell>
                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.size}</TableCell>
                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.price}</TableCell>
                <TableCell align='center'>
                  <IconButton color='secondary' onClick={() => handleConfirmOpen(cateringmenu.id)}>
                      <DeleteIcon />
                  </IconButton>
                  <IconButton color='secondary' onClick={() => handleClickOpenEdit(cateringmenu)}>
                      <EditIcon />
                  </IconButton>
              </TableCell>
              </TableRow>
                ) ): (<TableRow><TableCell>Loading... </TableCell></TableRow>)}
            </TableBody>
          </Table>
          <TablePagination  sx={{ fontSize: '1.1rem' }}
            component="div"
            count={cateringMenus!= null? cateringMenus.length: 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}  // Options for rows per page
        />
      </TableContainer>
      <hr></hr>
    </Card>
      {/* Confirmation Dialog for Deletion */}
      <Dialog open={confirmOpen}
        style={{ width: '600px', maxWidth: '600px' }} // Custom width 
        onClose={handleConfirmClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this catering menu?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(deleteId);
            }}
            color="secondary"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

       {/* Modal Dialog for Adding New Product */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New Catering Menu</DialogTitle>
        <DialogContent>

          <TextField
            margin="dense"
            name="name"
            label="Menu Name"
            type="text"
            fullWidth
            value={newCateringMenu.name}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="description"
            label="Description"
            type="text"
            fullWidth
            value={newCateringMenu.description}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="size"
            label="Size"
            type="text"
            fullWidth
            value={newCateringMenu.size}
            onChange={handleChange}
          />
            <TextField
                margin="dense"
                name="price"
                label="Price"
                type="text"
                fullWidth
                value={newCateringMenu.price}
                onChange={handleChange}
            />
            <select
                style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    marginBottom: '15px',
                    fontSize: '16px',
                    height:'50px'
                }}
                id="categoryid"
                onChange={handleCategoryChange}
                value={newCateringMenu.category}
            >
                <option>Choose Category...</option>
                {categories.map(category => (
                    <option key={category} value={category} >
                        {category}
                    </option>
                ))}
            </select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddCateringMenu} color="primary" variant="contained">
            Add Product
          </Button>
        </DialogActions>
      </Dialog>

    {/* Modal Dialog for Editing Product */}
    <Dialog open={openEdit} onClose={handleCloseEdit}>
        <DialogTitle>Edit Product</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="name"
            label="Menu Title"
            type="text"
            fullWidth
            value={editCateringMenu.name}
            onChange={handleChangeEdit}
          />
          <TextField
            margin="dense"
            name="description"
            label="description"
            type="text"
            fullWidth
            value={editCateringMenu.description}
            onChange={handleChangeEdit}
          />
          <TextField
            margin="dense"
            name="size"
            label="size"
            type="text"
            fullWidth
            value={editCateringMenu.size}
            onChange={handleChangeEdit}
          />
            <TextField
                margin="dense"
                name="price"
                label="price"
                type="text"
                fullWidth
                value={editCateringMenu.price}
                onChange={handleChangeEdit}
            />
            <select
                style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    marginBottom: '15px',
                    fontSize: '16px',
                    height:'50px'
                }}
                id="categoryid"
                onChange={handleCategoryChange}
                value={editCateringMenu.category}
            >
                <option>Choose Category...</option>
                {categories.map(category => (
                    <option key={category} value={category} >
                        {category}
                    </option>
                ))}
            </select>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="primary">
              Cancel
            </Button>
            <Button color="primary" variant="contained"  onClick={handleEditCateringMenu} >
              Update Catering Menu
            </Button>
          </DialogActions>
    </Dialog>  
<Snackbar
  open={snackbarOpen}
  autoHideDuration={4000}
  onClose={handleSnackbarClose}
  anchorOrigin={{vertical: 'top', horizontal: 'right'}}
>
<Alert
  onClose={handleSnackbarClose}
  severity={snackbarSeverity}
  sx={{
    display: 'flex',
    alignItems: 'center',
    minHeight: '80px'
  }}
>
   {snackbarMessage}
</Alert>
</Snackbar>
</Box>
  )
}

